import { PieceSide } from '@seddi/scene';

import type { StyleLogoRegion } from '../api/styleAggregator';
import type { FrameBounds } from './frameLookAt';

type Box2Like = { min: { x: number; y: number }; max: { x: number; y: number } };

export const getBoxLocal = (region: StyleLogoRegion, target: Box2Like) => {
  const { size } = region;
  const halfX = size.x * 0.5;
  const halfY = size.y * 0.5;
  target.min.x = -halfX;
  target.min.y = -halfY;
  target.max.x = halfX;
  target.max.y = halfY;
};

const intersectsPoint = (box: Box2Like, x: number, y: number): boolean =>
  x >= box.min.x && x <= box.max.x && y >= box.min.y && y <= box.max.y;

export const boxIntersectsPoint = intersectsPoint;

export const finishFrameBounds = (region: StyleLogoRegion, target: FrameBounds) => {
  if (region.side === PieceSide.BACK) {
    target.normal.negate();
  }
};
